var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      key: _vm.stateChangeKey,
      attrs: { id: "mfa-recovery-form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.handleSubmit(_vm.recoveryText)
        }
      }
    },
    [
      _c("div", { staticClass: "w-100 mt-3 mb-4 text-center" }, [
        _c(
          "div",
          { staticClass: "d-flex-column justify-content-left mb-3 mt-3" },
          [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.recoveryText,
                  expression: "recoveryText",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "form-group form-control styled-input",
              class: { error: _vm.hasError },
              attrs: {
                placeholder: "Paste or type your recovery code",
                name: "recovery-text-input"
              },
              domProps: { value: _vm.recoveryText },
              on: {
                change: function($event) {
                  return _vm.$emit("resetErrors")
                },
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.recoveryText = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.hasError || _vm.warning
          ? _c("div", { staticClass: "w-100 para-3 error-text" }, [
              _vm.hasError
                ? _c("span", { staticClass: "text-bold error-message" }, [
                    _c("i"),
                    _vm._v(_vm._s(_vm.error[0]))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.warning
                ? _c("span", { style: { color: _vm.warningColor } }, [
                    _vm.hasError ? _c("br") : _vm._e(),
                    _c("i"),
                    _vm._v(_vm._s(_vm.warning))
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "AppButton",
        {
          staticClass: "w-100 mb-2",
          attrs: {
            name: _vm.submitButtonName,
            disabled: _vm.recoveryText.trim().length == 0 || _vm.isLoading,
            type: "submit",
            size: "medium",
            "data-target": _vm.dataTarget,
            loading: _vm.isLoading
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.submitButtonText) + "\n\t")]
      ),
      _vm._v(" "),
      _vm.showHelpAndRecovery
        ? _c("div", { staticClass: "help-section" }, [
            _c("p", { staticClass: "modal-pretext text-light text-center" }, [
              _c(
                "a",
                {
                  staticClass: "button-color",
                  on: { click: _vm.openOTPInputModal }
                },
                [_vm._v("Go Back")]
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "modal-pretext text-light text-center" }, [
              _vm._v("Or "),
              _c(
                "a",
                {
                  staticClass: "button-color",
                  on: { click: _vm.openHelpPageInNewTab }
                },
                [_vm._v("get help")]
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }